
<template>
  <div
    class="side-panel col-2"
    :class="{
      'mobile-layout': isMobile,
      collapsed: isMobile && isPanelCollapsed,
    }"
  >
    <div class="position-absolute w-100 h-100">
      <!-- >>sub panel with icons -->
      <div
        id="sub-panel-container"
        class="w-100 h-100 d-flex flex-column justify-content-center"
        :class="{ 'mobile-hidden': isMobile }"
      >
        <div class="sub-panel">
          <button
            v-for="category in categories"
            :key="category.fullName"
            @click="setActiveCategory(category.fullName)"
            :class="{ active: activeCategory === category.fullName }"
          >
            <img :src="category.icon" />
            <div>
              {{ category.name }}
            </div>
          </button>
        </div>
      </div>
      <div
        class="main-panel h-100 d-flex flex-column justify-content-start align-items-center"
        :class="{ 'mobile-main-panel': isMobile }"
      >
        <!-- Mobile Header with Collapse Button -->
        <div class="mobile-header-section" v-if="isMobile">
          <h2 id="categoryTitle">{{ activeCategory }}</h2>
          <div class="collapse-btn" @click="togglePanelCollapse">
            <span v-if="!isPanelCollapsed">▼</span>
            <span v-else>▲</span>
          </div>
        </div>
        <!-- >>traffic type html -->
        <div v-if="sceneManager.activeCategory == 'Noise'">
          <div class="traffic-type-buttons">
            <!-- noise types -->
            <!-- <button
              class="noiseTypeButton road-traffic"
              :class="{ selected: trafficType === 'road' }"
              @click="setTrafficType('road')"
            >
              Road Traffic
            </button> -->
            <!-- <button
              class="noiseTypeButton marine-traffic"
              :class="{ selected: trafficType === 'marine' }"
              @click="setTrafficType('marine')"
            >
              Marine Traffic
            </button> -->
          </div>
        </div>
        <!-- >>main panel of VP lists -->
        <ul class="list" v-if="!isPanelCollapsed || !isMobile">
          <!-- Main Map option for mobile -->
          <li
            v-if="isMobile"
            class="clickable main-map-item"
            :class="{ selected: isMainMapSelected }"
            @click="handleMainMapClick"
          >
            MAIN MAP
          </li>
          <h2 id="categoryTitle">{{ activeCategory }}</h2>
          <li
            v-for="item in activeMainList"
            :key="item"
            :class="{
              clickable: item.clickable,
              unclickable: !item.clickable,
              selected: isSelected(item),
            }"
            @click="handleItemClick(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- Noise legend copied from noise panel (buttons excluded) -->
        <div
          v-if="activeCategory === 'Noise' && !sceneManager.mapShow"
          class="legend"
          id="noiseLegend"
        >
          <div id="legendTitle">Legend</div>
          <div class="legendItems green">
            <span class="complied legendIcon"></span>
            <label>Comply with the criteria</label>
          </div>
          <div class="legendItems red">
            <span class="exceeded legendIcon"></span>
            <label>Exceed the criteria</label>
          </div>
          <div
            class="legendItems blue1"
            :style="{ display: noiseLegend.showBlue ? 'flex' : 'none' }"
          >
            <span class="blue legendIcon"></span>
            <label class="blueLabel"
              >Comply with the criteria (with acoustic windows /
              balconies)</label
            >
          </div>
          <div
            class="legendItems noiseBarrier"
            :style="{ display: noiseLegend.showNoiseBarrier ? 'flex' : 'none' }"
          >
            <span class="legendIcon"></span>
            <label class="noiseBarrierLabel"
              >Comply with the criteria (with acoustic windows / balconies
              lined with sound absorptive material)</label
            >
          </div>
          <div
            class="legendItems yellow1"
            :style="{ display: noiseLegend.showYellow ? 'flex' : 'none' }"
          >
            <span class="yellow legendIcon"></span>
            <label class="yellowLabel">Proposed low noise road surfacing</label>
          </div>
          <div class="remark" style="margin-top: 1vw; font-size: 0.7rem">
            <label
              >Remark : <br />
              In the mitigated scenario, some existing NSRs exceed the relevant
              noise criteria due to high traffic noise levels from existing
              roads. In accordance with EIAO Guidance Note No. 12/2023, direct
              mitigation measures, if required, are proposed to reduce the noise
              from the project road(s) to a level that it: 
              <br>
              (i) is not higher
              than the standard laid down in Annex 5 of the EIAO-TM; and
              <br>
              (ii)
              has no significant contribution to the overall noise compared to
              other existing roads, if the cumulative noise level exceeds the
              standard.<br>Therefore, no further direct mitigation measures are
              required.
            </label>
          </div>
        </div>
        <img
          id="habitatLegend1"
          src="/webframe/map/image/NTW_Legends-20250916.webp"
          alt=""
          srcset=""
          v-if="activeCategory === 'Habitat Map'"
        />

        <div v-if="activeCategory === 'Habitat Map'" class="ecology-resources">
          <p class="ecology-title">Key Ecological Resources:</p>
          <ul class="ecology-list">
            <li class="ecology-item" @click="openEcologyModal(1)">
              Wetland Habitats
            </li>
            <li class="ecology-item" @click="openEcologyModal(2)">
              Wooded Areas on <br />
              Ngau Tam Shan
            </li>
            <li class="ecology-item" @click="openEcologyModal(3)">
              Species of Conservation Importance
            </li>
            <li class="ecology-item" @click="openEcologyModal(4)">
              Flight Corridor
            </li>
          </ul>
        </div>

        <div id="bottomContainer" v-if="activeCategory === 'Water Quality'">
          <p id="instruction">Select a scenario</p>
          <button
            id="mitigatedBtn"
            class="button mitigated"
            :class="{ selected: sceneManager.WQMitigatedState }"
            @click="sceneManager.WQMitigatedState = true"
          >
            Mitigated
          </button>
          <button
            id="unmitigatedBtn"
            class="button unmitigated"
            :class="{ selected: !sceneManager.WQMitigatedState }"
            @click="sceneManager.WQMitigatedState = false"
          >
            Unmitigated
          </button>
          <hr />
          <div class="legend">
            <div id="legendTitle">Legend</div>
            <div class="legendItems">
              <span class="complied legendIcon"></span>
              <label>Complied with the criteria</label>
            </div>
            <div class="legendItems">
              <span class="exceeded legendIcon"></span>
              <label>Exceeded the criteria</label>
            </div>
            <div class="legendItems blue1">
              <span class="na legendIcon"></span>
              <label class="blue"
                >Not applicable due to provisioning of noise insulation with
                air-conditioning</label
              >
            </div>
          </div>
        </div>
        <div
          id="prevailing"
          class="ecology-resources"
          v-if="
            sceneManager.activeCategory == 'Noise' ||
            sceneManager.activeCategory == 'Air Quality' ||
            sceneManager.activeCategory == 'Landscape & Visual'
          "
        >
          <ul class="ecology-list">
            <!-- <li
              v-if="activeCategory == 'Noise' && trafficType == 'road'"
              class="ecology-item"
              @click="openModal('Noise')"
            >
              Prevailing Background Noise
            </li> -->
            <!-- <li
              v-if="
                activeCategory == 'Noise' &&
                trafficType == 'road' &&
                !sceneManager.mapShow &&
                isNoiseBarrierSupported
              "
              class="ecology-item"
              :class="{
                'noise-barrier-active': sceneManager.noiseBarrierVisible,
              }"
              @click="toggleNoiseBarrierInfo"
            >
              Noise Barrier Info
            </li> -->
            <img
              id="noiseBarrierLegend"
              :src="noiseBarrierLegend"
              alt="Noise Barrier Legend"
              v-if="
                activeCategory === 'Noise' && sceneManager.noiseBarrierVisible
              "
            />
            <li
              v-if="activeCategory == 'Noise' && trafficType == 'marine'"
              class="ecology-item"
              @click="openModal('Noise')"
            >
              Prevailing Marine Traffic Noise
            </li>
            <li
              v-if="activeCategory === 'Air Quality'"
              class="ecology-item"
              @click="openModal('Air Quality')"
            >
              Background Air Pollutants Concentration
            </li>
            <li
              v-if="activeCategory === 'Air Quality'"
              class="ecology-item"
              @click="openOdourModal()"
            >
              Odour Impact
            </li>
            <li
              v-if="activeCategory === 'Landscape & Visual'"
              class="ecology-item clickable"
              @click="openLandscapePlansModal"
            >
              Landscape Plans under Mitigated Scenario
            </li>
          </ul>
        </div>
        <div id="goToMap" v-if="!sceneManager.mapShow && !isMobile">
          <router-link to="/eia">
            <div @click="showMap">
              <span class="mirrored-arrow">➜</span> Back to map
            </div>
          </router-link>
        </div>

        <!-- Mobile Tabs at Bottom -->
        <div class="mobile-tabs-bottom" v-if="isMobile">
          <div
            class="tab"
            v-for="category in categories"
            :key="category.fullName"
            :class="{ active: activeCategory === category.fullName }"
            @click="setActiveCategory(category.fullName)"
          >
            <img :src="category.icon" />
            <span>{{ category.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showModal" class="modal-container">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <iframe
        :src="modalIframeSrc"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  </div>

  <!-- Image Carousel Modal -->
  <ImageCarouselModal
    :isVisible="showCarouselModal"
    :title="carouselConfig.title"
    :imagePath="carouselConfig.imagePath"
    :totalImages="carouselConfig.totalImages"
    :imageFilePattern="carouselConfig.imageFilePattern"
    :startPage="carouselConfig.startPage"
    @close="closeCarouselModal"
    @pageChange="onCarouselPageChange"
  />
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { sceneManager } from "@/store/sceneManager";
import { categories } from "@/data/categories";
import noiseBarrierLegend from "@/assets/noise-barrier/NTW_Legends NB_20250819.png";
import ImageCarouselModal from "./ImageCarouselModal.vue";

const activeCategory = ref("Viewpoints");
const isMobile = ref(false);
const isPanelCollapsed = ref(false);
const isMainMapSelected = computed(() => {
  return sceneManager.mapShow;
});

// Check if mobile
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

//>> check if the VP is selected
const isSelected = (item) => {
  // If map is showing, no VP should be selected
  if (sceneManager.mapShow) {
    return false;
  }
  // If map is not showing, check if this VP matches the current scene
  return item.link === sceneManager.currentScene;
};

const showMap = () => {
  sceneManager.mapShow = true;
  sceneManager.currentScene = "Panoramas Background";
};

const activeMainList = computed(() => {
  const category = categories.find(
    (cat) => cat.fullName === activeCategory.value
  );

  //>> if traffic type is marine, return the marine list, otherwise return the noise list
  if (trafficType.value === "marine" && activeCategory.value === "Noise") {
    return category ? category.marine_list : [];
  } else {
    return category ? category.list : [];
  }
});

const handleItemClick = (item) => {
  if (item.clickable) {
    if (activeCategory.value === "Landscape & Visual") {
      // Use sceneManager to store the selected LVI
      sceneManager.selectedLVI = item.link;  // Use link instead of name for map markers
      sceneManager.mapShow = true;
    } else {
      sceneManager.currentScene = item.link;
      sceneManager.triggerOverlayName = item.triggerOverlayName;
      sceneManager.mapShow = false; // This will automatically deselect main map
    }
  }
};

const setActiveCategory = (category) => {
  // Add check for Ecology category
  if (
    category === "Habitat Map" ||
    category === "Water Quality" ||
    category === "Landscape & Visual"
  ) {
    showMap();
  }
  if (category === "Other Aspects") {
    //pop up a modal that shows Other_Aspects_20241026.html
    modalIframeSrc.value = "/text/Other_Aspects_20241026.html";
    showModal.value = true;
  } else {
    activeCategory.value = category;
    sceneManager.activeCategory = category;
    updateTriggerOverlayName();
  }
};

//>> update the trigger overlay name
const updateTriggerOverlayName = () => {
  const category = categories.find(
    (cat) => cat.fullName === activeCategory.value
  );
  if (category) {
    const list =
      activeCategory.value === "Noise" && trafficType.value === "marine"
        ? category.marine_list
        : category.list;

    const item = list.find((item) => item.link === sceneManager.currentScene);
    if (item && item.triggerOverlayName) {
      sceneManager.triggerOverlayName = item.triggerOverlayName;
    } else {
      // Set a default trigger overlay name if no specific one is found
      sceneManager.triggerOverlayName = "";
    }
  }
};

//>> modal pop up that shows the iframe
const showModal = ref(false);
const modalIframeSrc = ref("");

// Image carousel modal state
const showCarouselModal = ref(false);
const carouselConfig = ref({
  title: "",
  imagePath: "",
  totalImages: 0,
  imageFilePattern: "",
  startPage: 1,
});

const openModal = (activeCategory) => {
  if (activeCategory === "Noise") {
    if (trafficType.value === "road") {
      modalIframeSrc.value = "/table/PrevailingBackgroundNoise.html";
    } else if (trafficType.value === "marine") {
      modalIframeSrc.value = "/table/PrevailingMarineTrafficNoise.html";
    }
  } else if (activeCategory === "Air Quality") {
    modalIframeSrc.value = "/table/BackgroundAirPollutantsConcentration.html";
  }

  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
};

const openLandscapePlansModal = () => {
  carouselConfig.value = {
    title: "Landscape Plans under Mitigated Scenario",
    imagePath: "/landscape-plans",
    totalImages: 5,
    imageFilePattern: "{number}.webp",
    startPage: 1,
  };
  showCarouselModal.value = true;
};

const closeCarouselModal = () => {
  showCarouselModal.value = false;
};

const onCarouselPageChange = (page) => {
  console.log(`Current page: ${page}`);
};

const openOdourModal = () => {
  // For now, using the same modal as Air Quality - you can customize this later
  modalIframeSrc.value = "/webframe/odour_impact/odour_impact.html";
  showModal.value = true;
};

const openEcologyModal = (ecologyNumber) => {
  // Try to use the map page's modal system via postMessage
  const mapIframe = document.getElementById("map");

  if (mapIframe && mapIframe.contentWindow) {
    // Send message to map iframe to open ecology modal
    mapIframe.contentWindow.postMessage(
      { type: "openEcologyModal", ecologyNumber: ecologyNumber },
      "*"
    );
  } else {
    // Fallback to the Vue component's modal system if map iframe is not available
    modalIframeSrc.value = `/webframe/ecology/index.html?data=${ecologyNumber}`;
    showModal.value = true;
  }
};

const trafficType = ref("road");
const setTrafficType = (type) => {
  trafficType.value = type;
  updateTriggerOverlayName();
};

// Mobile panel methods
const togglePanelCollapse = () => {
  isPanelCollapsed.value = !isPanelCollapsed.value;
};

const handleMainMapClick = () => {
  sceneManager.mapShow = true;
  sceneManager.currentScene = "Panoramas Background";
};

const toggleNoiseBarrierInfo = () => {
  sceneManager.toggleNoiseBarrierInfo();
};

// Check if current scene supports noise barriers
const isNoiseBarrierSupported = computed(() => {
  const currentScene = sceneManager.currentScene;
  return ["VP1", "VP2", "VP3"].includes(currentScene);
});

// Noise legend state derived from current scenario
const noiseLegend = computed(() => {
  const scenario = sceneManager.noiseScenario;
  const flags = sceneManager.noiseLegendFlags || [];
  const hasYellow = flags.includes("yellow1") || flags.includes("yellow_green");
  return {
    showBlue: scenario === "mitigated",
    showNoiseBarrier: scenario === "mitigated",
    // Show yellow only when legend flags indicate and scenario is mitigated (matches panel behavior)
    // showYellow: scenario === "mitigated" && hasYellow,
    showYellow: true,
  };
});

// Listen for scenario change messages from noise panel (direct or via map bridge)
const handleNoiseScenarioMessage = (event) => {
  // Direct string messages from noise panel iframe
  if (event && typeof event.data === "string") {
    if (
      event.data === "mitigated" ||
      event.data === "unmitigated" ||
      event.data === "prevailed"
    ) {
      sceneManager.setNoiseScenario(event.data);
      return;
    }
  }
  // Bridged object messages via map iframe
  if (event && event.data && event.data.type === "noiseScenario") {
    const value = event.data.value;
    if (
      value === "mitigated" ||
      value === "unmitigated" ||
      value === "prevailed"
    ) {
      sceneManager.setNoiseScenario(value);
    }
  }
};

onMounted(() => {
  checkMobile();
  window.addEventListener("resize", checkMobile);
  window.addEventListener("message", handleNoiseScenarioMessage);

  // Reset to Overview/Viewpoints when component mounts (when navigating back to EIA page)
  activeCategory.value = "Viewpoints";
  sceneManager.activeCategory = "Viewpoints";
  sceneManager.mapShow = true;
  sceneManager.currentScene = "Panoramas Background";
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
  window.removeEventListener("message", handleNoiseScenarioMessage);
});
</script>

<style scoped>
* {
  text-decoration: none !important;
}

.side-panel {
  position: absolute;
  top: 12vh;
  height: 88vh;
  right: 0;
  display: flex;
  font-family: Arial, sans-serif;
}

.main-panel {
  padding: 1.5vw 0.5vw 1.5vw 1.5vw;
  background-color: #f4f4f4;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Custom scrollbar for main panel */
.main-panel::-webkit-scrollbar {
  width: 16px; /* Make scrollbar wider/chubby */
}

.main-panel::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 8px;
  margin: 70px 0; /* Add margin to top and bottom */
}

.main-panel::-webkit-scrollbar-thumb {
  background: #008768;
  border-radius: 8px;
  border: 2px solid #e1e1e1;
  margin: 70px 0; /* Add margin to top and bottom */
}

.main-panel::-webkit-scrollbar-thumb:hover {
  background: #006b54;
}

.main-panel h2 {
  font: 25px arial, sans-serif;
  color: #008768;
  padding: 1.6vh;
  text-align: center;
  margin-bottom: 0;
}

.main-panel ul {
  list-style-type: none;
  /* padding: 20px; */
  width: 100%;
}

.main-panel ul li {
  padding: 0.3vw !important;
  font: 2.5vh sans-serif;
  cursor: pointer;
  width: auto;
  text-align: center;
  border-radius: 10px;
}

.main-panel ul li.unclickable {
  /* background-color: rgb(214, 214, 214); */
  cursor: default;
  font-weight: bold;
}

.main-panel ul li.noData {
  cursor: default;
  color: rgb(188, 188, 188);
}

.main-panel ul li.clickable:not(.selected):hover {
  background-color: rgb(214, 214, 214);
}

#sub-panel-container {
  pointer-events: none;
  position: absolute;
  left: -65px;
  height: 88vh;
}
.sub-panel {
  width: 65px;
  pointer-events: auto;
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
}

.sub-panel button {
  width: 100%;
  height: 65px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05); /* add a subtle bottom border */
  background: white;
  padding: 8px 6px;
  text-align: center;
  cursor: pointer;
  font: 12px sans-serif;
  color: #6b7280;
  border-radius: 18px 0 0 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sub-panel button.active {
  background-color: #008768;
  color: white;
}

.sub-panel img {
  width: 24px;
  height: 24px;
  margin-bottom: 6px;
  filter: brightness(0) saturate(100%) invert(47%) sepia(8%) saturate(1234%)
    hue-rotate(118deg) brightness(95%) contrast(86%);
}

.sub-panel button.active img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%)
    hue-rotate(93deg) brightness(103%) contrast(103%);
}

#categoryTitle {
  font-size: 1.7vw !important;
}

ul.list {
  list-style-type: none;
  padding: 0;
  margin-bottom: 0;
}

ul.list li {
  margin-bottom: 5px;
}

#goToMap {
  position: sticky;
  margin-top: auto;
  bottom: 0;
  width: 100%;
  padding: 0.5vh 0px 0px 0px;
  text-decoration: none !important;
}

#goToMap div {
  /* rounded corner green button */
  background-color: #008768;
  /* add border */
  /* border: 2px solid #008768; */
  color: #ffffff;
  width: auto;
  height: auto;
  margin: auto;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border-radius: 15px;
  font: 1rem sans-serif;
  z-index: 100;
  /* remove link style */
  text-decoration: none !important;
  /* background-color: #fefefe; */
}

#habitatLegend1 {
  width: 80%;
  height: auto;
  margin-top: 10px;
}

#noiseBarrierLegend {
  width: 100%;
  height: auto;
  margin-top: 10px;
}

.noise-barrier-active {
  background-color: #008768 !important;
  color: white !important;
  font-weight: bold;
}

/* below for WQ */

#bottomContainer {
  width: 100%;
  margin-top: 10vh;
  /* margin-bottom: auto; */
}
#instruction {
  width: 100%;
  text-align: center;
  font-size: 1.2vw;
}

.button {
  display: block;
  width: 80%;
  margin: 0.5vw auto;
  padding: 0.8vw;
  text-align: center;
  font-size: 1vw;
  font-weight: bold;
  cursor: pointer;
  color: rgb(0, 0, 0);
  border: #004d40 solid 3px;
  background: none;
}
.selected {
  background-color: #004d40; /* Dark green */
  border: #004d40 solid 3px;
  color: white !important;
}

hr {
  width: 100%;
  margin-top: 1vw;
  margin-bottom: 1vw;
  height: 1px;
  background-color: #535353cb;
  border: none;
}
.legend {
  text-align: left;
  font-size:calc(0.4rem + 0.5vw);
  padding-top: 15px;
}

#legendTitle {
  font-weight: 600;
  margin-bottom: 12px !important;
}

.legendItems {
  display: flex;
  align-items: center;
  margin-top: 0.4vw;
  gap: 8px;
}
/* Removed erroneous rule that widened the blue icon */

.legendItems label {
  flex-grow: 1;
  padding-left: 10px;
}

.legendIcon {
  /* display: block; */
  display: inline-block;
  width: 14px !important;
  height: 14px;
  aspect-ratio: 1 / 1;
  flex: 0 0 14px;
  border-radius: 2px;
  vertical-align: middle;
  /* margin-right: 4vw; */
  /* padding-right: 4vw; */
}

/* Match noise panel legend colors and sizes */
.complied {
  background-color: #3eff50;
}
.exceeded {
  background-color: #ff0000;
}
.blue {
  background-color: #005aff;
}
.yellow {
  background-color: #ffd700;
}
.lightGreen {
  background-color: #98fb98;
}
.noiseBarrier .legendIcon {
  background-color: #b636ff;
}

.legendItems .blueLabel {
  font-size: 1em;
  padding-left: 10px;
  width: auto;
}
.noiseBarrierLabel {
  font-size: 1em;
  padding-left: 10px;
  width: auto;
}

.blue1 {
  display: none;
}

/* modal */

.modal-container {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #fefefe;
  padding: 0px;
  border: 1px solid #888;
  width: 80%;
  height: 80%;
  position: relative;
}

.close {
  display: inline-block; /* required for vertical-align to work nicely */
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center; /* center horizontally */
  font-size: 40px;
  vertical-align: middle; /* aligns with the middle of surrounding text/line */
  cursor: pointer;
  position: absolute;
  top: -20px;
  right: -20px;
  border-radius: 50px;
  background-color: #ffffff;
  color: #000000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-family: Arial, sans-serif;
  vertical-align: middle !important;
}

.close:hover,
.close:focus {
  color: rgb(255, 255, 255);
  background-color: #008768;
  text-decoration: none;
  cursor: pointer;
}

.traffic-type-buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.noiseTypeButton {
  flex: 1;
  margin: 0 0.2rem;
  padding: 0.1rem;
  font-size: 0.9rem;
  border: 2px solid #008768;
  background-color: #ffffff;
  color: #008768;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.noiseTypeButton.selected {
  background-color: #008768;
  color: #ffffff;
}

.main-panel ul li.selected.noData {
  background-color: #a0a0a0; /* Example color */
  color: #ffffff; /* Example text color */
  cursor: default;
}

.noiseTypeButton:first-child {
  margin-left: 0;
}

.noiseTypeButton:last-child {
  margin-right: 0;
}

.main-panel ul li.selected {
  background-color: #008768;
  border: none;
  /* color: white; */
}

.air-quality-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
}

.air-quality-item {
  cursor: pointer;
  text-decoration: underline !important;
  font: 0.9vw sans-serif;
}

.air-quality-item:hover {
  color: #008768;
}

/* Ecology Resources Styles */
.ecology-resources {
  margin-top: 20px;
  width: 100%;
}

.ecology-title {
  font-size: 0.9vw;
  font-weight: bold;
  color: #008768;
  margin-bottom: 10px;
  text-align: center;
}

.ecology-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.ecology-item {
  padding: 8px 12px;
  margin: 5px 0;
  cursor: pointer;
  text-align: center;
  font-size: 0.9vw !important;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #ffffff;
  transition: all 0.3s ease;
  text-decoration: underline;
  color: #008768;
}

.ecology-item:hover {
  background-color: #f0f8f5;
  border-color: #008768;
  transform: translateY(-1px);
}

.mirrored-arrow {
  transform: scaleX(-1);
  display: inline-block;
}

/* Mobile Layout Styles */
@media screen and (max-width: 768px) {
  .side-panel.mobile-layout {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 50%;
    border-radius: 20px 20px 0 0;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 999;
    overflow: hidden;
    transition: height 0.3s ease-in-out;
  }

  .side-panel.mobile-layout.collapsed {
    height: 140px; /* Increased to accommodate header + tabs */
  }

  .mobile-hidden {
    display: none !important;
  }

  .mobile-main-panel {
    padding: 0 !important;
    background-color: transparent !important;
    height: 100% !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }

  /* Mobile Header Section */
  .mobile-header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    background-color: #f8f8f8;
    height: 80px;
    z-index: 2;
    position: sticky;
    top: 0;
    width: 100%;
    flex-shrink: 0;
  }

  .collapse-btn {
    width: 30px;
    height: 30px;
    border: 1px solid #00353e;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: white;
    color: #00353e;
    font-size: 14px;
  }

  /* Mobile Tabs at Bottom */
  .mobile-tabs-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    padding: 8px;
    background-color: #f8f8f8;
    border-top: 1px solid #eee;
    height: 60px;
    z-index: 1;
  }

  .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    color: #666;
    font-size: 12px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    padding: 10px 5px;
    border-radius: 8px 8px 0 0;
    transition: all 0.3s ease;
  }

  .tab.active {
    color: #00353e;
    font-weight: 600;
    background-color: white;
  }

  .tab img {
    width: 20px;
    height: 20px;
    margin-bottom: 5px;
    filter: brightness(0) saturate(100%) invert(47%) sepia(8%) saturate(1234%)
      hue-rotate(118deg) brightness(95%) contrast(86%);
  }

  .tab.active img {
    filter: brightness(0) saturate(100%) invert(20%) sepia(20%) saturate(2000%)
      hue-rotate(180deg) brightness(10%) contrast(100%);
  }

  .tab span {
    font-size: 12px;
  }

  /* Mobile Content Adjustments */
  .mobile-main-panel h2 {
    font-size: 24px !important;
    padding: 15px !important;
    margin: 0 !important;
  }

  .mobile-main-panel #categoryTitle {
    font-size: 20px !important;
    text-align: left !important;
    margin: 0 !important;
    flex: 1;
  }

  .mobile-main-panel ul.list {
    padding: 0 20px;
  }

  .mobile-main-panel ul.list li {
    padding: 12px 15px !important;
    font-size: 16px !important;
    margin-bottom: 8px;
    border-radius: 8px;
    border: 1px solid #eee;
  }

  .mobile-main-panel ul.list li.clickable:hover {
    background-color: #f5f5f5;
  }

  .mobile-main-panel ul.list li.selected {
    background-color: #008768;
    color: white;
    border-color: #008768;
  }

  .mobile-main-panel ul.list li.main-map-item {
    background-color: #a8d5e2;
    color: #00353e;
    font-weight: bold;
  }

  .mobile-main-panel ul.list li.main-map-item.selected {
    background-color: #00353e;
    color: white;
  }

  /* Mobile Traffic Type Buttons */
  .mobile-main-panel .traffic-type-buttons {
    margin: 15px 20px;
  }

  .mobile-main-panel .noiseTypeButton {
    padding: 10px;
    font-size: 14px;
  }

  /* Mobile Water Quality */
  .mobile-main-panel #bottomContainer {
    padding: 0 20px;
  }

  .mobile-main-panel #instruction {
    font-size: 16px;
  }

  .mobile-main-panel .button {
    width: 100%;
    margin: 10px 0;
    padding: 12px;
    font-size: 16px;
  }

  .mobile-main-panel .legend {
    font-size: 14px;
  }

  .mobile-main-panel .legendItems {
    margin-top: 15px;
  }

  .mobile-main-panel .WQMitigation-title {
    font-size: 16px !important;
  }

  .mobile-main-panel .WQMitigation-item {
    font-size: 14px !important;
  }

  /* Mobile Prevailing */
  .mobile-main-panel #prevailing {
    padding: 0 20px;
    margin-top: 20px;
  }

  .mobile-main-panel #prevailing .ecology-item {
    font-size: 14px !important;
  }

  /* Mobile Go To Map */
  .mobile-main-panel #goToMap {
    padding: 20px;
  }

  .mobile-main-panel #goToMap div {
    font-size: 16px;
    padding: 15px;
  }

  /* Mobile Habitat Legend */
  .mobile-main-panel #habitatLegend1 {
    margin: 20px;
    width: calc(100% - 40px);
  }

  /* Mobile Noise Barrier Legend */
  .mobile-main-panel #noiseBarrierLegend {
    margin: 20px;
    width: calc(100% - 40px);
  }
}
</style>